import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const ActivityTab = ({ formattedSentToExpertDate, formattedSentToReporterDate }) => (
  <>
    <Box sx={{ p: 2, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
        Sent to Client on:
      </Typography>
      <Typography variant="body1" sx={{ ml: 1 }}>
        {formattedSentToExpertDate}
      </Typography>
    </Box>
    <Box sx={{ p: 2, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
        Sent to Reporter on:
      </Typography>
      <Typography variant="body1" sx={{ ml: 1 }}>
        {formattedSentToReporterDate}
      </Typography>
    </Box>
  </>
);

ActivityTab.propTypes = {
  formattedSentToExpertDate: PropTypes.string.isRequired,
  formattedSentToReporterDate: PropTypes.string.isRequired,
};

export default ActivityTab;
